// Module
var code = "<div class=\"vs-enhanced-vh-child-hosts\"> <virtual-host-grid [vh-matches]=\"$ctrl.vhMatches\" (on-add)=\"$ctrl.addVHMatch()\" (on-edit)=\"$ctrl.editVHMatch($event)\" (on-delete)=\"$ctrl.deleteVHMatch($event)\"></virtual-host-grid> </div> ";
// Exports
export default code;